import './Features.css';
import img from '../../../resources/Group 1000003406.png'

function Features() {
    return (
        <div className='features_outer_div'>
            <div className='all_margin'>
                <div className='margin_auto_width'>
                    <div className='padding_top padding_bottom'>
                        <div className='features_heading_text text_align_center'>
                            <h1>Revolutionize Your <span className='green_gradient_p_animated'>Routine</span></h1>
                            <p className='gray_scale_2 font_size_20 font_weight_400'>Track your nutrition, and stay on top of your wellness goals—anytime, anywhere.</p>
                        </div>

                        <div className='features_main_grid_div'>
                            <div>
                                <img src={img} className='ntai_image' />
                            </div>

                            <div>
                                <div className='features_indiv_detail'>
                                    <p className='font_size_20 font_weight_500 gray_scale_6'>AI-Powered Macro Tracking, Made Effortless</p>
                                    <p className='font_size_18 font_weight_400 gray_scale_2'>
                                        Track your food using AI: snap a photo, speak, or chat—whichever you prefer. PrepWize understands meal logging in any language and delivers accurate macro and calorie tracking. No manual entry, just instant nutrition insights.
                                    </p>
                                    <p className='features_indiv_detail_step_num'>01</p>

                                </div>

                                <div className='features_indiv_detail'>
                                    <p className='font_size_20 font_weight_500 gray_scale_6'>Keep up with Your Health Goals</p>
                                    <p className='font_size_18 font_weight_400 gray_scale_2'>Stay on track with our app's comprehensive features, helping you monitor daily calories and progress toward weight loss, muscle gain, or a balanced lifestyle. Our water tracker ensures you’re meeting your hydration needs.</p>
                                    <p className='features_indiv_detail_step_num'>02</p>
                                </div>
                                <div className='features_indiv_detail'>
                                    <p className='font_size_20 font_weight_500 gray_scale_6'>Get Detail Insights on Your Meals</p>
                                    <p className='font_size_18 font_weight_400 gray_scale_2'>Gain detailed insights on every meal with our in-depth analytics. Track calories, protein, carbs, and more to make informed choices that support your health goals. Plus, explore cost analytics to balance nutrition with your budget.</p>
                                    <p className='features_indiv_detail_step_num'>03</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Features;
